var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconKey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.948 1.333A10.725 10.725 0 0 0 9.866 15.695L1.5 24.063a.564.564 0 0 0-.166.399v5.64c0 .312.253.565.564.565h5.641a.564.564 0 0 0 .564-.564v-2.82h2.82a.564.564 0 0 0 .565-.565v-2.82h2.82c.15 0 .293-.06.4-.166l1.598-1.598a10.719 10.719 0 1 0 3.643-20.8zm-3.56 19.553a.556.556 0 0 0-.619.116l-1.666 1.666H11a.556.556 0 0 0-.556.555V26H7.667a.556.556 0 0 0-.556.556v2.777H2.667v-4.769l8.332-8.332a.555.555 0 0 0 .115-.618 9.444 9.444 0 0 1 14.07-11.322 9.444 9.444 0 0 1-5.296 17.265 9.396 9.396 0 0 1-3.5-.67zM24 9.333a1.333 1.333 0 1 1-2.667 0 1.333 1.333 0 0 1 2.667 0z",
    fill: "#D14925",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconKey);
export default __webpack_public_path__ + "static/media/icon-key.580ef384651fa62a0588b7e324a61900.svg";
export { ForwardRef as ReactComponent };